import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSeller, editSeller, fetchProvinciaLocalidadByCodigoPostal, clearLocalidadProvincia } from '../../actions/sellersActions';
import Cleave from 'cleave.js/react';
import Select from 'react-select';
import { DropDownArrow, customStyle } from '../../template/CustomStyle';

class DatosContactos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            codigoPostalAnterior: null,
        };
        this.domilicioInputRef = React.createRef();
    };

    componentDidMount() {
        if (this.domilicioInputRef.current) {
            this.domilicioInputRef.current.focus();
        }

        const { seller } = this.props;

        //crea un seller
        if (!seller?.id) {
            this.props.clearLocalidadProvincia();
        }
    }

    myChangeHandler = (event) => {
        const { name, value } = event.target;

        this.setState({
            didEdit: true
        });

        let seller = { ...this.props.seller };

        if (name === 'codigoPostal') {
            const codigoPostalStr = String(value);

            if (codigoPostalStr !== this.state.codigoPostalAnterior) {

                // Limpiamos los campos y el store
                seller.provincia = '';
                seller.localidad = '';
                this.props.editSeller(seller);
                this.props.clearLocalidadProvincia();

                this.setState({ codigoPostalAnterior: codigoPostalStr });

                if (codigoPostalStr.length === 4) {
                    const request = { codPostal: codigoPostalStr };
                    this.props.fetchProvinciaLocalidadByCodigoPostal(request);
                }

                seller[name] = value;
                this.props.editSeller(seller);

                return;
            }
        }

        seller[name] = value;
        this.props.editSeller(seller);
    };

    render() {
        let { seller, localidadProvincia } = this.props;

        const provinciasOptions = localidadProvincia?.nombreProvincia?.map(prov => ({
            label: prov,
            value: prov
        })) || [];

        const provinciaSeleccionada = provinciasOptions.find(
            option => option.value === seller.provincia
        ) || (seller.provincia ? { label: seller.provincia, value: seller.provincia } : null);

        const localidadesOptions = localidadProvincia?.localidades?.map(loc => ({
            label: loc,
            value: loc
        })) || [];

        const localidadSeleccionada = localidadesOptions.find(
            option => option.value === seller.localidad
        ) || (seller.localidad ? { label: seller.localidad, value: seller.localidad } : null);

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="card-body">

                    <h4 className="card-title">Institucional</h4>

                    <div className="row">

                        <div className="form-group col-lg-6">
                            <label>Calle</label>
                            <input
                                type="text"
                                className="form-control"
                                value={seller.domicilio || ""}
                                onChange={this.myChangeHandler}
                                name="domicilio"
                                ref={this.domilicioInputRef}
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Altura</label>
                            <Cleave
                                className="form-control"
                                name="numeroDomicilio"
                                value={seller.numeroDomicilio || ""}
                                options={{ blocks: [5], numericOnly: true }}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Código Postal </label>
                            <Cleave
                                className="form-control"
                                name="codigoPostal"
                                value={seller.codigoPostal || ""}
                                options={{ blocks: [4], numericOnly: true }}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Localidad</label>
                            <Select
                                name="localidad"
                                value={localidadSeleccionada ? localidadSeleccionada : seller.localidad}
                                options={localidadesOptions}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                onChange={(selectedOption) => this.myChangeHandler({ target: { name: 'localidad', value: selectedOption.value } })}
                                styles={customStyle}
                                menuPortalTarget={document.body}
                                placeholder="Seleccione una localidad"
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Provincia</label>
                            <Select
                                name="provincia"
                                value={provinciaSeleccionada ? provinciaSeleccionada : seller.provincia}
                                options={provinciasOptions}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                onChange={(selectedOption) => this.myChangeHandler({ target: { name: 'provincia', value: selectedOption.value } })}
                                styles={customStyle}
                                placeholder="Seleccione una provincia"
                                menuPortalTarget={document.body}
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Teléfono</label>
                            <Cleave
                                className="form-control"
                                name="telefono"
                                value={seller.telefono || ""}
                                options={{ blocks: [10], numericOnly: true }}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    seller: JSON.stringify(state.general.generalObject) != "{}" ? state.general.generalObject : state.sellers.seller,
    tipoUsuario: state.general.tipoUsuario,
    localidadProvincia: state.sellers.provinciasLocalidades ?? [],
});

export default connect(mapStateToProps, { fetchSeller, editSeller, fetchProvinciaLocalidadByCodigoPostal, clearLocalidadProvincia })(DatosContactos);